import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { authRoles } from 'app/auth';

import GroupServicesLayout from './support/layouts/GroupServicesLayout';

const ServicesListPage = lazy(() => import('./support/ServicesListPage'));

const ServicesConfig = {
  settings: {
    layout: {
      config: {
        footer: {
          display: false,
        },
        healtheraHeader: {
          display: true,
          options: {
            pharmacySelector: true,
          },
        },
      },
    },
  },
  auth: authRoles.pharmacist,
  routes: [
    {
      path: 'services',
      element: (
        <GroupServicesLayout>
          <ServicesListPage />
        </GroupServicesLayout>
      ),
    },
    {
      path: 'services/:serviceId',
      element: <Navigate to="settings" replace />,
      settings: {
        layout: {
          config: {
            healtheraHeader: {
              display: true,
              options: {
                pharmacySelector: false,
              },
            },
          },
        },
      },
    },
  ],
};

export default ServicesConfig;
